import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

/**
 * Email notifications — paged.
 * @param {number} offset
 * @param {number} limit defaults to 20
 */
export const getEmailNotificationList = async (offset = 0, limit = 20) => {
    try {
        return await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/alert-box/email-notifications/${offset}/${limit}`
        );
    } catch (error) {
        console.error(error);
    }
};

/**
 * SMS notifications — paged.
 * @param {number} offset
 * @param {number} limit defaults to 20
 */
export const getSmsNotificationList = async (offset = 0, limit = 20) => {
    try {
        return await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/alert-box/sms-notifications/${offset}/${limit}`
        );
    } catch (error) {
        console.error(error);
    }
};

/**
 * Calls — no paging
 */
export const getCallLogList = async () => {
    try {
        return await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/alert-box/call-notifications`
        );
    } catch (error) {
        console.error(error);
    }
};

export const sendEmails = async (data) => {
    try {
        return await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/action-center/trigger`,
            data
        );
    } catch (error) {
        console.error(error);
    }
};
